import axios from 'axios';

const client = axios.create({
  baseURL: 'https://developers.onemap.sg',
  responseType: 'json'
});

export default client;
